import { useEffect } from "react";
import useGet from "./useGet";
import useSelectSearch from "./useSelectSearch";
import { TSearchOptions } from "../../types/common";

type TSearchOptionsConfig = {
  api: string;
  toOption: (item: any) => any;
  searchParam?: string;
  params?: Record<string, any>;
  selected?: any;
  enabled?: boolean;
  delay?: number;
};

const useSearchOptions = ({
  api,
  toOption,
  searchParam = "search",
  params,
  selected,
  enabled = true,
  delay = 400,
}: TSearchOptionsConfig): TSearchOptions & { data: any } => {
  const { loadData, data, loading } = useGet();
  const { searchValue, onSearch } = useSelectSearch({ delay });

  const query = {
    ...params,
    ...(searchValue ? { [searchParam]: searchValue } : {}),
  };
  const queryKey = JSON.stringify(query);

  useEffect(() => {
    if (!enabled) return;
    loadData({ api, params: query });
  }, [api, queryKey, enabled]);

  const records = Array.isArray(data) ? data : data?.results || [];
  const options = records.map(toOption);

  return {
    options:
      selected?.value && !options.some((o: any) => o.value === selected.value)
        ? [selected, ...options]
        : options,
    loading,
    onSearch,
    data,
  };
};

export default useSearchOptions;
